module.exports = __webpack_public_path__ + "static/media/vr-gallery.2f7669dc.webp";